import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import HistoricalCheckboxes from './form';
import { HistoricalFormVM } from 'front-office/view-models/historical/historical-form';
import { DateTime } from 'luxon';

const HistoricalAnprComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<HistoricalFormVM>();

  const onChange = useCallback(
    (identifier) => {
      const isSelected =
        formContext.values.historical?.key.codiceDocumento === identifier.key.codiceDocumento;

      formContext.setFieldValue('historical', isSelected ? undefined : identifier);

      if (!formContext.values.certificateInternOnly && identifier.dettaglioModalitaRilascio) {
        formContext.setFieldValue(
          'modality',
          isSelected
            ? undefined
            : {
                id: identifier.dettaglioModalitaRilascio.key.codiceModalitaRilascio,
                value: identifier.dettaglioModalitaRilascio.descrizione,
                amountTaxStamp: identifier.dettaglioModalitaRilascio.importoImpostaBollo
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoImpostaBollo)
                  : 0,
                amountRightsSecretariat: identifier.dettaglioModalitaRilascio
                  .importoDirittiSegreteria
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiSegreteria)
                  : 0,
                amountRightsCivilState: identifier.dettaglioModalitaRilascio
                  .importoDirittiStatoCivile
                  ? Number.parseFloat(
                      identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile
                    )
                  : 0,
                amountFixedRights: identifier.dettaglioModalitaRilascio.importoDirittiFissi
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiFissi)
                  : 0,
                amountExpenses: identifier.dettaglioModalitaRilascio.importoSpese
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoSpese)
                  : 0,
                codeExemptionAnpr: identifier.dettaglioModalitaRilascio.codiceEsenzioneAnpr,
                registryType: identifier.dettaglioModalitaRilascio.tipoRegistro,
                descrizioneModalitaStampa:
                  identifier.dettaglioModalitaRilascio.descrizioneModalitaStampa,
                disabled: true,
              }
        );
      }
      //for death related certification dateForm will be equals to dateOfDeathOfApplicant otherwiese currentDate
      if (!formContext?.values?.dateForm) {
        if (formContext?.values?.accountholder?.sameApplicant) {
          if (
            formContext?.values?.applicant?.deathDate &&
            (formContext?.values?.historical?.key?.codiceDocumento === '11' ||
              formContext?.values?.historical?.key?.codiceDocumento === '13')
          ) {
            formContext?.setFieldValue('dateForm', formContext?.values?.applicant?.deathDate);
          } else {
            formContext?.setFieldValue('dateForm', DateTime.now());
          }
        } else {
          if (
            formContext?.values?.accountholder?.account?.applicant?.deathDate &&
            (formContext?.values?.historical?.key?.codiceDocumento === '11' ||
              formContext?.values?.historical?.key?.codiceDocumento === '13')
          ) {
            formContext?.setFieldValue(
              'dateForm',
              formContext?.values?.accountholder?.account?.applicant?.deathDate
            );
          } else {
            formContext?.setFieldValue('dateForm', DateTime.now());
          }
        }
      }
    },
    [
      formContext.setFieldValue,
      formContext.values.historical,
      formContext?.values?.dateForm,
      formContext?.values?.applicant?.deathDate,
      formContext?.values?.accountholder?.account?.applicant?.deathDate,
      formContext?.values?.accountholder?.sameApplicant,
    ]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-historical-anpr-content"
        id="panel-historical-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Storiche</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <HistoricalCheckboxes
            onChange={onChange}
            values={formContext.values.historical}
            isAire={
              formContext.values.accountholder?.isAire ||
              (formContext.values.isAire && formContext.values.accountholder?.sameApplicant)
                ? '1'
                : '0'
            }
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

HistoricalAnprComponent.displayName = 'Accordion historical anpr component';

const HistoricalAnpr = memo(HistoricalAnprComponent);

export default HistoricalAnpr;
